import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useNavbarContext } from './NavbarContext';
export const NavbarCollapse = ({ children }) => {
    const { isOpen } = useNavbarContext();
    return (_jsx("div", { className: classNames('w-full md:block md:w-auto', { hidden: !isOpen }), children: _jsx("ul", { className: "mt-4 flex flex-col md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium", children: children }) }));
};
